import React, { useEffect, useState } from "react";
import InterviewMetaDataCard from "./manageStudents/InterviewMetaDataCard";
import InterviewTableMain from "./manageStudents/InterviewTableMain";
import Utils from "../../../../utils/Utils";
import WebUtils from "../../../../utils/WebUtils";
import { getIDronaDetailsApi } from "../../../../api/org-admin";

function ManageStudents({setLoading, iDronaId}) {
  const userDetail = Utils.getUserDetail();
  const [jobDetails, setJobDetails] = useState(null);

  const getGuideDetails = () => {
    const url = `${getIDronaDetailsApi}?organizationId=${
      userDetail?.organizationId || null
    }&iDronaInterviewConfigurationId=${iDronaId}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setJobDetails(result?.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getGuideDetails();
  }, []);

  return (
    <div>
      <InterviewMetaDataCard
        jobDetails={jobDetails}
        iDronaId={iDronaId}
        setLoading={setLoading}
      />
      <InterviewTableMain
        userDetail={userDetail}
        iDronaId={iDronaId}
        setLoading={setLoading}
        getGuideDetails={getGuideDetails}
      />
    </div>
  );
}

export default ManageStudents;
